import http from "src/services/http";
import queryString from "query-string";
import store from "src/store";
import * as types from "../types/complementos";

export const cadastrar = (complemento) => {
  store.dispatch({ type: types.LOADING_COMPLEMENTO, payload: true });

  const { filtro } = store.getState().complementos;
  return http.post(`/api/v2/empresa/complementos`, complemento).then(
    (response) => {
      store.dispatch([
        {
          type: types.SET_COMPLEMENTO,
          payload: { titulo: "", descricao: "", icone: "" },
        },
        pesquisarComplementos(filtro),
      ]);
    },
    (error) => {
      store.dispatch([{ type: types.LOADING_COMPLEMENTO, payload: false }]);
    }
  );
};

export const atualizar = ({ id, ...complemento }) => {
  store.dispatch({ type: types.LOADING_COMPLEMENTO, payload: true });

  const { filtro } = store.getState().complementos;
  return http.put(`/api/v2/empresa/complementos/${id}`, complemento).then(
    (response) => {
      store.dispatch([
        { type: types.SET_COMPLEMENTO, payload: { titulo: "" } },
        pesquisarComplementos(filtro),
      ]);
    },
    (error) => {
      store.dispatch([{ type: types.LOADING_COMPLEMENTO, payload: false }]);
    }
  );
};
export const pesquisarComplementos = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  return (dispatch) => {
    http.get(`/api/v2/empresa/complementos?${qry}`).then(
      (resp) => {
        const { total, current_page: page, per_page, data } = resp.data;
        store.dispatch([
          { type: types.LOAD_COMPLEMENTOS, payload: data },
          { type: types.SET_PAGE_COMPLEMENTO, payload: parseInt(page) },
          { type: types.SET_TOTAL_COMPLEMENTO, payload: parseInt(total) },
          { type: types.SET_PERPAGE_COMPLEMENTO, payload: parseInt(per_page) },
          { type: types.LOADING_COMPLEMENTO, payload: false },
        ]);
      },
      (error) => {
        store.dispatch([{ type: types.LOADING_COMPLEMENTO, payload: false }]);
      }
    );
  };
};

export const excluirComplemento = (id) => {
  const { filtro } = store.getState().complementos;
  store.dispatch({ type: types.LOADING_COMPLEMENTO, payload: true });
  return http.delete(`/api/v2/empresa/complementos/${id}`).then(
    (response) => {
      store.dispatch(pesquisarComplementos(filtro));
    },
    (error) => {
      store.dispatch([{ type: types.LOADING_COMPLEMENTO, payload: false }]);
    }
  );
};
